import type React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RootState } from "../../../../store/Index";
import { useSelector } from "react-redux";
import formatDate from "../../../../utils/FormatDate";

interface ForecastItem {
  date: string;
  event: string;
  location: string;
  time: string;
}

interface ForecastTableProps {
  data: ForecastItem[];
}

const ForecastTable: React.FC<ForecastTableProps> = ({ data }) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Card sx={{ boxShadow: 0 }}>
      <CardHeader
        title={<Typography variant="h6">10-Day Forecast</Typography>}
      />
      <CardContent>
        <TableContainer sx={{ width: "100%" }}>
          <Table>
            <TableHead
              sx={{
                backgroundColor: reduxTheme.primary_colors?.[800] || "#E5BFA5",
              }}
            >
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Event</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Start Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.slice(0, 5).map((shoot, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor:
                      index % 2 === 0
                        ? "white"
                        : reduxTheme.primary_colors?.[800] || "#E5BFA5",
                  }}
                >
                  <TableCell>{formatDate(shoot.date)}</TableCell>
                  <TableCell>{shoot.event}</TableCell>
                  <TableCell>{shoot.location}</TableCell>
                  <TableCell>{shoot.time}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default ForecastTable;
